const mapSizes = [
  { width: 640, height: 270 },
  { width: 575, height: 160 },
  { width: 475, height: 160 },
  { width: 375, height: 160 },
  { width: 320, height: 160 }
];

export default mapSizes;
